import {
  toWSDateString,
  WSPillTheme,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import {
  AccountTransactionDirection,
  Currency,
  ListTaxWithholdingTransactionsFilterParameterStatusEq as TaxWithholdingTransactionStatus,
  TaxWithholdingTransaction
} from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { selectorTaxWithholdingTransactionTitle } from "../../selectors/selectorTaxWithholdingTransactionTitle";

const statusPillTheme: Record<TaxWithholdingTransactionStatus, WSPillTheme> = {
  [TaxWithholdingTransactionStatus.SCHEDULED]: "warning",
  [TaxWithholdingTransactionStatus.PROCESSING]: "blue",
  [TaxWithholdingTransactionStatus.POSTED]: "success",
  [TaxWithholdingTransactionStatus.FAILED]: "error",
  [TaxWithholdingTransactionStatus.CANCELLED]: "neutral"
};

export const columns: Array<WSTableColumn<TaxWithholdingTransaction>> = [
  {
    config: {
      header: { text: "Transaction" },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={selectorTaxWithholdingTransactionTitle(rowItem.data)}
        secondaryText={
          rowItem.data.invoiceNumber
            ? `Invoice #${rowItem.data.invoiceNumber}`
            : undefined
        }
      />
    )
  },
  {
    config: {
      header: { text: "Date" },
      gridTemplateSizeMax: "0.4fr"
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={toWSDateString(rowItem.data.effectiveAt, "monthDayYear")}
      />
    )
  },
  {
    config: {
      header: { text: "Status" },
      gridTemplateSizeMax: "0.4fr",
      hideOnScreens: ["XS"]
    },
    renderFunction: rowItem => (
      <WSTableCell
        pill={{
          text: rowItem.data.status,
          theme: statusPillTheme[rowItem.data.status]
        }}
      />
    )
  },
  {
    config: {
      header: { text: "Amount" },
      gridTemplateSizeMax: "0.4fr",
      justify: "end"
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={formatMoney(
          Number(rowItem.data.amount) *
            (rowItem.data.direction === AccountTransactionDirection.DEBIT
              ? -1
              : 1),
          rowItem.data.currency ?? Currency.USD,
          { showSign: true }
        )}
      />
    )
  }
];
